"use client";
import React, { useRef, useEffect, useState } from 'react';

import { generateUrl, getSearchParams, redirectToLink, setRouting, adobeData, isBeforeCutoff, generateAdobeDataRaceNo, generateAdobeDataHorseName, defaultValue,} from "@/app/utils/Common";
import { isValidDate, toDate, formattedDate, toDayJS, compareDate, dateFormat, minDate, withinDate } from "@/app/utils/DayJS";
import "@/app/style/upcomingRaces.scss"; 
import { MyContext, useMyContext } from '@/app/utils/MyContext';
import { LANGTYPE_EN, useLanguage } from "@/app/utils/LanguageContext"; 
import { MenuTab } from '@/app/utils/class/common/base';
import { menuTabSet } from '@/app/utils/constant/menuTabSet';
import { Swiper, SwiperSlide, useSwiper,  } from 'swiper/react';
import { Pagination, Navigation, Autoplay  } from 'swiper/modules';
import SwiperCore from 'swiper';
import { RaceNo as RaceNoObj } from '@/app/utils/class/common/base';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import { inherits } from 'util';
const UpComingRaceCards = (props:any) => {
    const { handleSelectRace, handleSelectMeeting} = props;
    const { upComingList } = props;
    const { state: lang } = useLanguage();
    const { t } = lang;
 
    const [cards, setCards] = useState([] as any);
    const [currace, setcurrace] = useState("");

    const { state: myContextState, dispatch: myContextDispatch } = useMyContext();  
    const { RaceDate, Racecourse, RaceNo } = getSearchParams(new URLSearchParams(window.location.search));
    
    const [isMobile, setisMobile] = useState(props.type == "mobile");
    const [slidesPerGroup, setslidesPerGroup] = useState(1);
    const [swiperInstance, setSwiperInstance] = useState<SwiperCore>();
    const [pendingRaceUpdate, setPendingRaceUpdate] = useState<any>(null);
    const [shaddowRight , setshaddowRight  ] = useState<Boolean | undefined>(false);
    const [shaddowLeft , setshaddowLeft  ] = useState<Boolean | undefined>(false);

    const [slidesOffsetAfter, setslidesOffsetAfter] = useState(0);
    const [curmtId, setcurmtId] = useState("");
    const [isOneBRelease, setisOneBRelease] = useState(true);
    
    useEffect(() => {

        if(props?.mtId && props?.mtId != "All"){
            const newData = upComingList?.filter((x: any) => x.id == props?.mtId);
            setCards(newData);
        }else {
            setCards(upComingList);
        }
        setTimeout(() => {
             setshaddowRight(swiperInstance?.isEnd);
            setshaddowLeft(swiperInstance?.isBeginning) 
        });
       
    },[props?.mtId, upComingList, myContextState.selectedMeetingVenueCode, myContextState?.selectedRaceNo])

    useEffect(() => {
        console.log('UpComingRaceCards---', upComingList,myContextState.selectedMeetingVenueCode, myContextState?.selectedRaceNo?.valueOf?.())
        const tarRaceId = `${myContextState.selectedMeeting?.id}${myContextState.selectedMeetingVenueCode}-${myContextState?.selectedRaceNo}`
        if (myContextState.selectedMeeting?.id && myContextState.selectedMeetingVenueCode && myContextState?.selectedRaceNo) setcurrace(tarRaceId)

        const tarRaceIndex = cards?.findLastIndex((i:any) => i?.raceId == tarRaceId);
        
        console.log('tarRaceIndex---', tarRaceIndex, swiperInstance)
        if (tarRaceIndex > -1) {
            swiperInstance?.slideTo(tarRaceIndex, 300)
        }
      
    }, [myContextState.selectedMeetingVenueCode, myContextState?.selectedRaceNo])


    // Handle dynamic component interaction updates without reloading pages
    useEffect(() => {
        if (!pendingRaceUpdate) return;

        const currentMenuTab = myContextState.menuTab;

        const c = pendingRaceUpdate;
        const raceSummaryMenuTab = new MenuTab(menuTabSet.RACE_SUMMARY);
        const raceResultMenuTab = new MenuTab(menuTabSet.RESULTS); 
        const raceEntriesMenuTab = new MenuTab(menuTabSet.ENTRIES); 
        const raceRaceCardMenuTab = new MenuTab(menuTabSet.RACE_CARD);
        
        let targetMenuTab = currentMenuTab;
        switch (c?.dataSourse) {
        case "qids":
            targetMenuTab = (c?.status === "RESULT" || c?.status === "CLOSED") ? raceResultMenuTab : raceRaceCardMenuTab;
            break;
        case "cms":
            targetMenuTab = c?.isEntriesReady ? raceEntriesMenuTab : raceSummaryMenuTab;
            break;
        default:
            break;
        }
    
        const parsedTargetDate = toDate(c?.raceDate, dateFormat.cms.datetime);
    
        // Sync routing parameters inside state transitions cleanly 
        setRouting(`/${encodeURIComponent(targetMenuTab.valueOf())}`, { 
            'RaceDate': c?.raceDate,
            'Racecourse': c?.raceCourse,
            'RaceNo': c?.raceNo
        }, myContextState);
    
        myContextDispatch({
        type: "update", 
        value: {
            selectedMeeting: undefined,
            selectedRace: undefined,
            selectedMeetingDate: parsedTargetDate,
            selectedMeetingVenueCode: c?.raceCourse,
            selectedRaceNo: c?.raceNo,
            menuTab: targetMenuTab,
            isLoadingRaces: true,
            // Force dataSource bypass override switch if navigating historical elements
            dataSource: isBeforeCutoff(parsedTargetDate) ? "qids" : "both"
        }
        });
    
        // Complete block lifecycle sequence loop execution cleanly
        setPendingRaceUpdate(null);
    }, [pendingRaceUpdate, myContextState, myContextDispatch]);

    
    const handleupComOnclick = (c: any, e: React.MouseEvent) => {
        setcurrace(`${c?.raceId}`);
        if(window.globalConfig.OneBSwitch) {
            const parentElement = e.currentTarget.closest('.sticky-outer-wrapper');
            if (parentElement && parentElement.classList.contains('active')) {
                try {
                    setTimeout(() => {
                        parentElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
                    }, 60); 
                } catch (err) {
                    parentElement.scrollIntoView(true);
                }
            }
            setPendingRaceUpdate(c);
            adobeData(lang.langType === LANGTYPE_EN ? "en" : "zh-hk", "interaction", {
                pageId: "racing/simulcast",
                internalAd: "SPLDSP_racing/simulcast-UpcomingRace_Carousel_" + c?.timeLeft,
            });
        } else {
            handleupComOnclick1A(c)
        }
    };
    const handleupComOnclick1A = (c:any) => {
        setcurrace(`${c?.raceId}`)
       
        const raceSummaryMenuTab = new MenuTab(menuTabSet.RACE_SUMMARY);
        const raceResultMenuTab = new MenuTab(menuTabSet.RESULTS); 
        const raceEntriesMenuTab = new MenuTab(menuTabSet.ENTRIES); 
        const raceRaceCardMenuTab = new MenuTab(menuTabSet.RACE_CARD);
        const redirectFn = (menuTab:any) => {
            redirectToLink(generateUrl(`/${menuTab.valueOf()}`, { 
                "RaceDate": c?.raceDate,
                "Racecourse": c?.raceCourse,
                "RaceNo": c?.raceNo,
                "focus": "Y",
                "b_cid": "SPLDSP_racing/simulcast-UpcomingRace_Carousel_" + c?.timeLeft
            }), "_self")
        } 

        switch (c?.dataSourse) {
            case "qids":
                if (c?.status == "RESULT" || c?.status == "CLOSED") {
                    redirectFn(raceResultMenuTab)
                } else {
                    redirectFn(raceRaceCardMenuTab)
                }
                break;
            case "cms":
                if (c?.isEntriesReady) {
                    redirectFn(raceEntriesMenuTab)
                } else {
                    redirectFn(raceSummaryMenuTab)
                }
                break;
            default:
                break;
        }
      
    }
    const adjustOffsetFn = () => {
        // might use in 1b
        return 
        const swiperDom = (document.querySelector(".upComing_swiper") as any);
        const onescreenDisplay = swiperDom?.clientWidth == swiperDom?.scrollWidth ;
        const lastIndxOfJumped = cards?.findLastIndex((item:any) => item?.timeLeft == t("upcoming_stopsell"));
        const noJumpedDataOrIslastOne = (lastIndxOfJumped == -1) || (lastIndxOfJumped == (cards?.length - 1));
        console.log('onescreenDisplay----', onescreenDisplay, noJumpedDataOrIslastOne)
        if (onescreenDisplay || noJumpedDataOrIslastOne) {
            setslidesOffsetAfter(0)
            return 
        }
        const wholeWidth = (document.querySelector(".racesItem") as any)?.clientWidth;
        const eachItemWidth = (document.querySelector('.UpComingRaceCards_Content') as any)?.clientWidth;
        // const slidersPer = Math.floor((wholeWidth / eachItemWidth) || 1);
        
        const offset = (wholeWidth - 22 - 8 - eachItemWidth) || 0;
        setslidesOffsetAfter(offset);
        // setslidesPerGroup(slidersPer);
        console.log('slidersPer----', wholeWidth, eachItemWidth)
    }
    const throttle = (fn:any, wait = 100) => {
        let last = 0;
        return (...args:any) => {
        const now = Date.now();
        if (now - last >= wait) {
            last = now;
            fn(...args);
        }
        };
    };
       
    useEffect(() => {

        const handleResize = throttle(adjustOffsetFn, 50)
        if(!isMobile) {
            adjustOffsetFn();
            window?.addEventListener('resize', handleResize, { passive: true });    
        }

        return () => {
            if(!isMobile) {
                window?.removeEventListener('resize', handleResize);
            }
        }
    })
    const onArrowClick = (type:string) => {
        switch (type) {
            case 'left':
                swiperInstance?.slidePrev();
                break;
            case 'right':
                swiperInstance?.slideNext();
                break;
            default:
                break;
        }
       
        setshaddowRight(swiperInstance?.isEnd);
        setshaddowLeft(swiperInstance?.isBeginning);
        // fix SQ0253-1970
        if ((type == 'left' && shaddowLeft) || (type == 'right' && shaddowRight)) return 
        adobeData(lang.langType === LANGTYPE_EN ? "en" : "zh-hk", "interaction", {
            pageId: "racing/simulcast",
            eventId: `racing/simulcast_Click_AnyPage_UpcomingRace-${type== 'left' ? 'Left' : 'Right'}`,
            country: myContextState.selectedMeeting?.countryNameEn || '',
            raceNo: generateAdobeDataRaceNo(myContextState.selectedMeetingDate, myContextState.selectedMeetingVenueCode, myContextState.selectedRaceNo?.valueOf()),
        });
    }

    const displayBgColor = (item: any) => {
        if (item?.timeLeft == t("upcoming_stopsell") || ["abandoned", "voided"].includes(item?.status?.toLowerCase())) return "grey"
        if (item?.less9min) return "red"
        return ""
    }

    useEffect(() => {
        const lastIndxOfJumped = cards?.findLastIndex((item:any) => item?.timeLeft == t("upcoming_stopsell")) 
        const noJumpedDataOrIslastOne = (lastIndxOfJumped == -1) || (lastIndxOfJumped == (cards?.length - 1));
        const lastRaceCompleted = ["abandoned", "voided"].includes(cards?.[cards?.length - 1]?.status?.toLowerCase());
        // interval reflesh will not trigger
        if (curmtId !== props?.mtId) {
            if (lastIndxOfJumped > -1 && !noJumpedDataOrIslastOne && !lastRaceCompleted) {
                swiperInstance?.slideTo(lastIndxOfJumped + 1, 300)
            } else {
                swiperInstance?.slideTo(0, 300)
            }
        }
    }, [props?.mtId, cards])
    useEffect(() => {
        setcurmtId(props?.mtId)
        // adjustOffsetFn();
        setisOneBRelease(window.globalConfig.OneBSwitch)
    }, [cards])
    const renderContent = () => {
        return <div className={"ArrowControl"} style={{padding:isMobile? "0 12px 12px 12px": "inherits"}}>
         {
            cards?.length > 0 ? <Swiper 
                onToEdge= {(swi: any) => {
                    setshaddowRight(swi.isEnd);
                    setshaddowLeft(swi.isBeginning)
                }}
                onTouchMove ={(swi: any) => {
                    setshaddowRight(swi.isEnd);
                    setshaddowLeft(swi.isBeginning)
                }}
                onSwiper={setSwiperInstance}
                modules={[Pagination,Navigation,Autoplay]} 
                spaceBetween={8}
                className={"upComing_swiper"}
                pagination={true}
                navigation={isMobile ? false : true}
                autoplay={false}        
                loop={false}
                slidesPerGroup ={1}
                slidesPerView={'auto'}
                slidesOffsetAfter={slidesOffsetAfter}
            >
            {cards?.map((c:any,index:number)=>{
                 const venRace = c?.venueCodeRaceNo;
                return (
                <SwiperSlide id={c?.raceId} className={`UpComingRaceCards_Content ${isMobile ? "isMobileMode" : ""}`} key={index}>
                    <div key={index} className={c?.raceId == currace ? "_upComActive" : ""} onClick={(e) => c?.raceId == currace ? null : handleupComOnclick(c, e)}>
                        <div>
                            <div className={c?.isTurf == null ? "" : (!c?.isTurf ? "wet" : "turf")}>
                                <span>{c?.postdate}</span>
                                <span>{venRace}</span>
                                <span>{c?.country}</span>
                            </div>

                            <div>
                                <span title={c?.raceName}>{c?.raceName}</span>
                                <span>{c?.isWorldPool ? <img style={isMobile ? { height: "10px", display: "block" } : { height: "14px" }} src={c?.isWorldPool} /> : ""}</span>
                                <span className={displayBgColor(c)}>{c?.timeLeft}</span>
                            </div>
                        </div>
                </div>
                </SwiperSlide>
                )
            })
            }                
            </Swiper>: null
         }
        </div> 
    }
    return !isMobile ? <div className={`ArrowControl-Root ${isOneBRelease ? "oneBRelease" : "oneARelease"}`}>
            <div onClick={() => onArrowClick("left")} className={!shaddowLeft ? "shaddowLeft": "noneCursor"} >
                {/* <KeyboardArrowLeftIcon style={{color: shaddowLeft ? '#8B8B8B':'#122C68'}}/> */}
                <svg width="6" height="10" viewBox="0 0 6 10" fill="none" xmlns="http://www.w3.org/2000/svg" >
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M4.23692 0.304493C4.64025 -0.101498 5.29418 -0.101498 5.6975 0.304493C6.10083 0.710483 6.10083 1.36872 5.6975 1.77471L2.49337 5L5.6975 8.22528C6.10083 8.63127 6.10083 9.28952 5.6975 9.69551C5.29418 10.1015 4.64025 10.1015 4.23692 9.69551L0.302497 5.73511C-0.100832 5.32912 -0.100832 4.67088 0.302497 4.26489L4.23692 0.304493Z" fill={shaddowLeft ? '#8B8B8B':'#122C68'}/>
                </svg>

                {/* <img src={`${myContextState.assetPrefix}/upcom_prev.svg`} style={{color: shaddowLeft ? '#8B8B8B':'#122C68'}}/> */}
            </div>
            {renderContent()}
            <div  onClick={() => onArrowClick("right")} className={!shaddowRight ? "shaddowRight": "noneCursor" } >
                {/* <KeyboardArrowRightIcon style={{color: shaddowRight ? '#8B8B8B':'#122C68'}} /> */}
                {/* <img src={`${myContextState.assetPrefix}/upcom_next.svg`} style={{color: shaddowRight ? '#8B8B8B':'#122C68'}}/> */}

                <svg width="6" height="10" viewBox="0 0 6 10" fill="none" xmlns="http://www.w3.org/2000/svg" >
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M1.76308 0.304493C1.35975 -0.101498 0.705824 -0.101498 0.302496 0.304493C-0.100833 0.710483 -0.100833 1.36872 0.302496 1.77471L3.50663 5L0.302496 8.22528C-0.100833 8.63127 -0.100833 9.28952 0.302496 9.69551C0.705823 10.1015 1.35975 10.1015 1.76308 9.69551L5.6975 5.73511C6.10083 5.32912 6.10083 4.67088 5.6975 4.26489L1.76308 0.304493Z" fill={shaddowRight ? '#8B8B8B':'#122C68'}/>
                </svg>

            </div>
        </div> : renderContent()
    
}

export default UpComingRaceCards;
